import { styles } from './styles'

type SnapshotAnnotationOverlayProps = {
  offset?: number
  x: number
  y: number
}

export const SnapshotAnnotationOverlay = ({
  offset = 10,
  x,
  y,
}: SnapshotAnnotationOverlayProps) => (
  <div
    className="snapshot-annotation-overlay"
    css={[
      styles,
      {
        top: `${y - offset}px`,
        left: `${x - offset}px`,
      },
    ]}
  />
)
